var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcDownload = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11L7.66086 11.3674L8 11.6805L8.33914 11.3674L8 11ZM8.5 3C8.5 2.72386 8.27614 2.5 8 2.5C7.72386 2.5 7.5 2.72386 7.5 3L8.5 3ZM3.66086 7.67509L7.66086 11.3674L8.33914 10.6326L4.33914 6.94029L3.66086 7.67509ZM8.33914 11.3674L12.3391 7.67509L11.6609 6.94029L7.66086 10.6326L8.33914 11.3674ZM8.5 11L8.5 3L7.5 3L7.5 11L8.5 11Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 13H12",
    stroke: "inherit",
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcDownload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-download.1ec082dcba16f57ac983a892a5a70cf8.svg";